import { render, staticRenderFns } from "./MSTATIONIntroduce.vue?vue&type=template&id=5b4c2275&scoped=true&"
import script from "./MSTATIONIntroduce.vue?vue&type=script&lang=js&"
export * from "./MSTATIONIntroduce.vue?vue&type=script&lang=js&"
import style0 from "./MSTATIONIntroduce.vue?vue&type=style&index=0&id=5b4c2275&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b4c2275",
  null
  
)

export default component.exports